import React from 'react';
import { useScreenSize } from '../../utils/media-query';
import { Button } from 'devextreme-react/button';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import DataGrid, { 
  Column, 
  Selection,
  FilterRow,
  Paging,
  Pager,
  // SearchPanel,
} from 'devextreme-react/data-grid';
import './style.scss';

export const employees = [
  { id: 1, fullName: "Nancy Davolio", status: 'Pending', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 2, fullName: "Nancy Davolio", status: 'Pending', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 3, fullName: "Nancy Davolio", status: 'Pending', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 4, fullName: "Nancy Davolio", status: 'Pending', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 5, fullName: "Nancy Davolio", status: 'Rejected', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 6, fullName: "Nancy Davolio", status: 'Approved', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 7, fullName: "Nancy Davolio", status: 'Rejected', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 8, fullName: "Nancy Davolio", status: 'Approved', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 9, fullName: "Nancy Davolio", status: 'Approved', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 10, fullName: "Nancy Davolio", status: 'Approved', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 11, fullName: "Nancy Davolio", status: 'Approved', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 12, fullName: "Nancy Davolio", status: 'Pending', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
  { id: 13, fullName: "Nancy Davolio", status: 'Pending', date: "2021-12-27T00:00:00.000Z", time: "1968-12-08T00:00:00.000Z"},
]

export default function Tables() {
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([]);

  const renderActions = (cellInfo) => {
    return (
      <React.Fragment>
        <Button
          type={(cellInfo.data.status !== 'Rejected') ? "danger" : "normal"}
          stylingMode="outlined"
          icon="close"
          className="button-rounded mr-2"
        />
        <Button
          type={(cellInfo.data.status !== 'Rejected') ? "default" : "normal"}
          stylingMode="outlined"
          text="Approve"
          className="button-rounded"
        />
      </React.Fragment>
    );
  }

  const onCellPrepared = (e) => {
    if(e.rowType === "data" && e.column.dataField === "status") {
      if (e.data.status === 'Pending') {
        e.cellElement.className = "color-accent";
      } else if (e.data.status === 'Approved') {
        e.cellElement.className = "color-success";
      } else {
        e.cellElement.className = "color-danger";
      }
    }
  }

  const onSelectionChanged = ({ selectedRowKeys, selectedRowsData }) => {
    setSelectedRowKeys(selectedRowKeys);
  }
  const { isXSmall } = useScreenSize();

  return (
    <React.Fragment>
      <Toolbar className="datagrid-toolbar-actions">
        <Item 
          location="after"
          locateInMenu={isXSmall ? 'always' : 'auto'}
          cssClass={"datagrid-toolbar-actions-dropdown"}
        >
          {
            (selectedRowKeys.length > 0) 
            && <React.Fragment>
              <Button 
                icon="copy"
                text="Copy"
                className="mr-1" />
              <Button 
                icon="trash"
                text="Delete"
                type="danger"
                stylingMode="outlined"
                className="mr-1" />
            </React.Fragment>
          }
          <Button 
            icon="edit"
            text="Edit"
            className="mr-1" />
          <Button 
            icon={`<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z" fill="#384455"/></svg>`}
            text="Export"
            className="mr-1" />
          <Button 
            icon="revert"
            text="Refresh"
            className="mr-1" />
          <Button 
            icon="plus"
            text="Create" 
            type="default"
            stylingMode="outlined" />
        </Item>
      </Toolbar>
      <DataGrid
        showBorders={true}
        showRowLines={true}
        hoverStateEnabled={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
        columnHidingEnabled={true}
        alignment="center"
        dataSource={employees}
        className="datagrid-has-toolbar-actions"
        onCellPrepared={onCellPrepared}
        onSelectionChanged={onSelectionChanged}
      >
        
        {/* <SearchPanel 
          visible={true}
          width={240}
          className="datagrid-toolbar-search-panel"
          placeholder="Search..." /> */}
        <Selection
          mode="multiple"
          selectAllMode="page"
          showCheckBoxesMode="always"
        />
        <FilterRow visible={true} />
        <Paging defaultPageSize={10} />
        <Pager
          showPageSizeSelector={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showInfo={true}
          visible={true}
        />
        <Column
          caption="No."
          dataField="id"
          dataType="string"
          width={70}
          alignment="center"
          hidingPriority={1}
        />
        <Column
          caption="Employee Name"
          dataField="fullName"
          dataType="string"
          width={200}
          allowSearch={true}
        />
        <Column
          caption="Status"
          dataField="status"
          dataType="string"
          hidingPriority={2}
          width={160}
        />
        <Column
          caption="Date"
          dataField="date"
          dataType="date"
          format="dd/MM/yyyy"
          hidingPriority={3}
          width={140}
        />
        <Column
          caption="Time"
          dataField="time"
          dataType="datetime"
          format="shortTime"
          hidingPriority={4}
          width={120}
        />
        <Column 
          caption="Action"
          cellRender={renderActions}
          alignment="center"
          hidingPriority={5}
        />
      </DataGrid>
    </React.Fragment>
)}
